// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4096":"c80ddb15","8620":"3c77d905"}[chunkId] + ".chunk.css";
};